var _polygon, _polygon2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _polygon3, _path, _path2, _path3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlexiformlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378.67 51.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.1,43.65V17.16H0v29.24c0,2.96,2.4,5.35,5.35,5.35h29.52v-8.1H8.1Z",
    style: {
      fill: "#088fc6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63,8.1v26.49h8.1V5.35c0-2.96-2.4-5.35-5.35-5.35H16.86V8.1h26.77Z",
    style: {
      fill: "#00477d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.14,
    y: 17.16,
    width: 17.44,
    height: 17.44,
    style: {
      fill: "#cb0c02"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "72.14 6.19 64.04 6.19 64.04 46.03 72.14 46.03 72.14 30.16 91.74 30.16 91.74 22.06 72.14 22.06 72.14 14.3 93.84 14.3 93.84 6.2 72.14 6.2 72.14 6.19"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.31 6.19 219.2 6.19 219.2 46.03 227.31 46.03 227.31 30.16 246.9 30.16 246.9 22.06 227.31 22.06 227.31 14.3 249 14.3 249 6.2 227.31 6.2 227.31 6.19"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98.23,
    y: 6.2,
    width: 8.1,
    height: 27.62
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.23,
    y: 37.93,
    width: 29.02,
    height: 8.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.13,
    y: 6.13,
    width: 29.82,
    height: 8.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 131.13,
    y: 21.59,
    width: 29.82,
    height: 8.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131.13,
    y: 37.93,
    width: 29.82,
    height: 8.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 203.68,
    y: 17.16,
    width: 8.1,
    height: 28.87
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 203.68,
    y: 6.2,
    width: 8.1,
    height: 6.37
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.78 6.12 177.42 24.78 163.02 46.02 163.04 46.03 172.8 46.03 182.32 31.99 191.83 46.03 201.6 46.03 201.61 46.02 174.56 6.12 164.78 6.12"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.26,46.03h8.1v-12.82l-8.1-16.05v28.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.31,5.45c-.11,0-.21,0-.32,.01v7.94c.11,0,.21-.02,.32-.02,7.21,0,12.05,5.04,12.05,12.55s-4.73,12.55-12.05,12.55-11.88-4.91-12.01-12.23h-8.52c.13,11.7,8.72,20.18,20.53,20.18s20.57-8.59,20.57-20.43-8.65-20.54-20.57-20.54Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M329.51,19.2h0c0-3.31-.9-6.02-2.42-8.1-1.64-2.25-3.99-3.76-6.75-4.48-1.23-.32-2.53-.48-3.89-.48h-17.67v6.82h17c.08,0,.17,0,.25,.01,3.13,.12,5.67,2.52,6,5.58,.03,.23,.04,.46,.04,.7,0,2.67-1.67,4.95-4.02,5.86-.71,.28-1.47,.43-2.28,.43h-17v20.42h8.1v-13.74c.99,0,1.99,.01,2.98,.02h3.25l9.33,13.76h9.78s-10.21-15.07-10.21-15.07c4.43-2.16,7.5-6.75,7.5-11.75Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "378.67 6.15 369.63 6.15 357.05 31.56 344.48 6.15 335.44 6.15 352.53 40.69 352.69 41.02 361.41 41.02 361.57 40.7 370.55 22.56 370.55 46.03 378.65 46.03 378.65 6.2 378.65 6.2 378.67 6.15"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 20.7 199.86 6.12 190.07 6.12 185.08 13.48 189.97 20.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexiformlogo);
export default __webpack_public_path__ + "static/media/flexiformlogo.76aab49364c7cee757e1b3c62e9a982a.svg";
export { ForwardRef as ReactComponent };